import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

// Global Components
import UserFullName from 'components/UserFullName';

interface Props {
    emails?: string[];
}

export class DocumentSetAssignedUsersList extends React.PureComponent<Props> {
    render() {
        const { emails } = this.props;
        if (!emails || !emails.length) return null;

        return (
            <React.Fragment>
                {emails.map((email, index) => (
                    <React.Fragment key={email}>
                        {!!index && ', '}
                        <UserFullName userEmail={email} />
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    emails: makeSelectDocumentSetValue('assignedUsers')
});

export default connect(mapStateToProps)(DocumentSetAssignedUsersList);
